if (!customElements.get('variant-selector-layer')) {
  customElements.define(
    'variant-selector-layer',
    class VariantSelectorLayer extends HTMLElement {
      constructor() {
        super();
        this.layer = this.querySelector('.variant-selector-layer__content');
        this.trigger = null;
        this.closeButton = this.querySelector('.variant-selector-layer__close');
        this.form = this.querySelector('form');
        this.variantButtons = this.querySelectorAll('.variant-option');
        this.submitButton = this.querySelector('[type="submit"]');
        this.variantIdInput = this.querySelector('[name="id"]');

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.close.bind(this));
        }

        this.variantButtons.forEach((button) => {
          button.addEventListener('click', this.onVariantSelect.bind(this));
        });

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }

        document.addEventListener('click', this.onBodyClick.bind(this));
        document.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE' && this.isOpen()) {
            this.close();
          }
        });
      }

      isOpen() {
        return this.classList.contains('active');
      }

      open(trigger) {
        // Close all other open layers first
        const allLayers = document.querySelectorAll('variant-selector-layer.active');
        allLayers.forEach((layer) => {
          if (layer !== this) {
            layer.close();
          }
        });

        this.trigger = trigger;
        this.classList.add('active');
        document.body.classList.add('overflow-hidden-mobile');
      }

      close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden-mobile');
        if (this.trigger) {
          this.trigger.focus();
        }
      }

      onBodyClick(event) {
        if (this.isOpen() && !this.layer.contains(event.target) && !event.target.closest('.variant-selector-trigger')) {
          this.close();
        }
      }

      onVariantSelect(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const variantId = button.dataset.variantId;
        const isAvailable = button.dataset.available === 'true';
        const variantPrice = button.dataset.variantPrice;

        if (!isAvailable) return;

        // Update selected state
        this.variantButtons.forEach((btn) => btn.classList.remove('selected'));
        button.classList.add('selected');

        // Update hidden input
        this.variantIdInput.value = variantId;
        this.variantIdInput.disabled = false;

        // Update submit button text with price
        const submitButtonText = this.submitButton.querySelector('.variant-selector-layer__submit-text');
        if (submitButtonText && variantPrice) {
          const addToCartText = submitButtonText.textContent.split(' - ')[0];
          submitButtonText.textContent = `${addToCartText} - ${variantPrice}`;
        }

        // Update submit button
        this.submitButton.removeAttribute('disabled');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.submitButton.hasAttribute('disabled')) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript',
          },
        };

        const formData = new FormData(this.form);
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${window.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('Error adding to cart:', response);
              return;
            }

            if (!cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (typeof publish !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'variant-selector-layer',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.close();
            cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
